import {
  GIFTCARD_BALANCE_ERROR,
  GIFTCARD_BALANCE_SUCESS,
  GIFTCARD_BALANCE_LOADING,
  GIFTCARD_BALANCE_RESET,
} from '../types/GiftCardTypes';
import { callGetGiftcardBalance } from '../../services/GiftCardService';

const loadBalance = () => {
  return { type: GIFTCARD_BALANCE_LOADING };
};

const errorInGetBalance = (status) => {
  return { type: GIFTCARD_BALANCE_ERROR, status };
};

const setBalance = (balance) => {
  return { type: GIFTCARD_BALANCE_SUCESS, balance };
};

export const resetBalance = () => {
  return { type: GIFTCARD_BALANCE_RESET };
};

export const getGiftcardBalance = (cardNumber) => {
  return async (dispatch) => {
    dispatch(loadBalance());
    try {
      const res = await callGetGiftcardBalance(cardNumber);
      if (res.status !== 200) {
        dispatch(errorInGetBalance(res.status));
      } else if (res.data.error.codigo !== 0) dispatch(errorInGetBalance(404));
      else dispatch(setBalance(res.data));
    } catch (e) {
      dispatch(errorInGetBalance());
    }
  };
};
